export const commentActionConstants  = {
    CLEAR_COMMENTS: 'CLEAR_COMMENTS',

    SET_COMMENTS: 'SET_COMMENTS',
    ADD_COMMENT: 'ADD_COMMENT',
    ADD_COMMENTS: 'ADD_COMMENTS',
    UPDATE_COMMENT: 'UPDATE_COMMENT',
    UPDATE_COMMENTS: 'UPDATE_COMMENTS',
    DELETE_COMMENT: 'DELETE_COMMENT',
    SET_HAS_NEXT_PAGE: 'SET_HAS_NEXT_PAGE',
    SET_CAN_ACCESS_COMMENT: 'SET_CAN_ACCESS_COMMENT',
};